import { STEP_PATHS } from '../step-constants';

const assetGroupStepConfig = i18n => ({
  id: STEP_PATHS.ASSET_GROUP,
  title: i18n.getString(_TL_('App assets ')),
});

const campaignTargetingStepConfig = i18n => ({
  id: STEP_PATHS.CAMPAIGN_TARGETING,
  title: i18n.getString(_TL_('Targets')),
});

const campaignSettingStepConfig = i18n => ({
  id: STEP_PATHS.CAMPAIGN_SETTING,
  title: i18n.getString(_TL_('Campaign settings')),
});

export const getStepListConfigCampaignCreation = ({ i18n }) => ([
  assetGroupStepConfig(i18n),
  campaignTargetingStepConfig(i18n),
  campaignSettingStepConfig(i18n),
]);

export const getStepListConfigCampaignEdit = ({ i18n }) => ([
  campaignTargetingStepConfig(i18n),
  campaignSettingStepConfig(i18n),
]);

export const getStepListConfigAssetGroupCreation = ({ i18n }) => ([
  assetGroupStepConfig(i18n),
  campaignTargetingStepConfig(i18n),
]);

